/** @graph-connects none */
export const NEGLIGENCE_LEVELS = [
  '0_過失なし',
  '1_軽度',
  '2_やや軽度',
  '3_やや重度',
  '4_重度',
  '5_超重度',
] as const;

/** @graph-connects none */
export const BUG_TYPES = [
  'バグ',
  'リリース',
  'パフォーマンス',
  'オペレーションミス',
  'バグではない',
  'セキュリティリスク',
] as const;

/** @graph-connects none */
export const RECURRENCE_OPTIONS = ['初回', '再発', 'バグではない'] as const;

/** @graph-connects none */
export const ANTI_PATTERN_OPTIONS = ['違反でない', '違反', 'バグではない'] as const;

/** @graph-connects none */
export const IRREGULAR_OPTIONS = ['レギュラー', 'イレギュラー', 'バグではない'] as const;

/** @graph-connects none */
export const DEV_FLOW_OPTIONS = ['準拠していない', '準拠している', 'バグではない'] as const;

/** @graph-connects none */
export const REVIEW_ROLES = ['admin', 'architect', 'tech_lead'] as const;

// 英語ラベルマップ。Firestore は日本語値で正規化されているため、表示時のみ翻訳。
/** @graph-connects none */
export const EN_LABELS: Record<string, Record<string, string>> = {
  bugType: {
    バグ: 'Bug',
    リリース: 'Release',
    パフォーマンス: 'Performance',
    オペレーションミス: 'Operational Error',
    バグではない: 'Not a Bug',
    セキュリティリスク: 'Security Risk',
  },
  negligenceLevel: {
    '0_過失なし': '0: No Fault',
    '1_軽度': '1: Minor',
    '2_やや軽度': '2: Slightly Minor',
    '3_やや重度': '3: Slightly Severe',
    '4_重度': '4: Severe',
    '5_超重度': '5: Critical',
  },
  recurrence: { 初回: 'First Occurrence', 再発: 'Recurrence', バグではない: 'Not a Bug' },
  antiPattern: { 違反でない: 'No Violation', 違反: 'Violation', バグではない: 'Not a Bug' },
  irregular: { レギュラー: 'Regular', イレギュラー: 'Irregular', バグではない: 'Not a Bug' },
  devFlowCompliance: {
    準拠していない: 'Non-Compliant',
    準拠している: 'Compliant',
    バグではない: 'Not a Bug',
  },
};
